import React from 'react';

const Card = ({
  children,
  title,
  subtitle,
  action,
  className = '',
  padding = true,
  hover = false,
  gradient = false,
  glow = false
}) => {
  const hoverClass = hover ? 'hover:shadow-glow hover:-translate-y-1 transition-all duration-300' : '';
  const paddingClass = padding ? 'p-6' : '';
  const glowClass = glow ? 'shadow-glow animate-pulse-slow' : '';
  const gradientBorder = gradient ? 'border-2 border-transparent bg-gradient-to-br from-primary-400 via-secondary-400 to-accent-400 bg-clip-border' : '';

  return (
    <div className={`glass-effect rounded-2xl shadow-xl ${hoverClass} ${glowClass} ${gradientBorder} ${className} overflow-hidden relative group`}>
      {gradient && (
        <div className="absolute inset-0 bg-gradient-to-br from-primary-500/10 via-secondary-500/10 to-accent-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
      )}
      {(title || action) && (
        <div className={`flex items-center justify-between border-b border-gray-200/50 backdrop-blur-sm ${padding ? 'px-6 py-4' : 'p-4'} relative z-10`}>
          <div>
            {title && <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
              {title}
              {glow && <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>}
            </h3>}
            {subtitle && <p className="text-sm text-gray-600 mt-1">{subtitle}</p>}
          </div>
          {action && <div className="relative z-10">{action}</div>}
        </div>
      )}
      <div className={`${paddingClass} relative z-10`}>
        {children}
      </div>
    </div>
  );
};

export default Card;
